//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientGraphQLAuthMutation, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import { v4 as uuidv4 } from 'uuid';
//Action types
import {
    AUTH_REFRESH_TOKEN,
    AUTH_CHANGE_PASSWORD_REQUEST,
    AUTH_GET_PREFERENCES_REQUEST,
    AUTH_GET_AUTHENTICATION_DETAILS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    refreshTokenResult,
    changePasswordResult,
    authGetPreferencesResult,
    authGetAuthenticationDetailsResult,
} from 'Redux/actions';

function* refreshToken() {
    try {
        let currentRefreshToken = localStorage.getItem('RefreshToken')
        if (!currentRefreshToken) {
            yield put(refreshTokenResult(false));
            return
        }

        let QUERY = `
            mutation refreshToken($refreshToken: String!) {
                result: refreshToken(refreshToken: $refreshToken) {
                    AccessToken
                    ExpiresIn
                    IdToken
                    RefreshToken
                }
            }
        `;

        let data = yield call(
            clientGraphQLAuthMutation,
            QUERY,
            {
                refreshToken: currentRefreshToken,
            }
        );

        if (data && data.result) {
            const { IdToken, AccessToken } = data.result
            localStorage.setItem('IdToken', IdToken);
            localStorage.setItem('AccessToken', AccessToken);
            yield put(refreshTokenResult(true));
        }
        else
            throw 'Error refresh token';

    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'refreshTokenRequest');
        yield put(refreshTokenResult(false));

    }
}

function* changePassword({ payload }) {
    try {

        let QUERY = `
            mutation changePassword (
                $accessToken: String!, 
                $oldPassword: String!, 
                $newPassword: String!
                ) {
                result: changePassword (
                    accessToken: $accessToken,
                    oldPassword: $oldPassword,
                    newPassword: $newPassword
                )
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                ...payload
            },
            endpoints.COGNITO_URL,
            {
                'x-api-key': endpoints.COGNITO_API_KEY
            }
        );
        if (data.result) {
            yield put(changePasswordResult(data.result, null));
        }
    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'changePassword');
        yield put(changePasswordResult(null, exc));
    }
}

function* getPreference() {
    try {
        let QUERY = `
            query getPreference ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: String!) {
                preference: getPreference (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKey: $preferenceKey) {
                    id
                    projectKey
                    entityName
                    entityId
                    preferenceKey
                    preferenceValue
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                projectKey: "PX",
                entityName: "System",
                entityId: "endPoints",
                preferenceKey: "environments"
            },
            endpoints.PX_CLOUD_API
        );

        yield put(authGetPreferencesResult(data?.preference && JSON.parse(data?.preference.preferenceValue)))
        sessionStorage.setItem("sessionId", uuidv4())
    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'getPreference');
    }
}

function* getAuthenticationDetails() {
    try {
        let QUERY = `
            query getAuthenticationDetails {
                result: getAuthenticationDetails {
                    authId
                    userId
                    username
                    email
                    fullname
                    permissions {
                        moduleId
                        code
                        c
                        u
                        d
                    }
                    isRestricted
                    dealerIds
                    dealerId
                }
            }
        `
        let data = yield call(
            clientQuery,
            QUERY,
            {},
            endpoints.GRAPHQL_GENERAL
        );
        if (data?.result) {
            if (data.result?.username) {
                localStorage.setItem("username", data.result.username);
            }
            yield put(authGetAuthenticationDetailsResult(data?.result))
        } else {
            // A 200 without a user would otherwise leave the shell on its loading overlay forever
            yield put(authGetAuthenticationDetailsResult(null, 'Empty response'))
        }

    } catch (exc) {
        if (exc?.error !== "Failed to fetch") {
            localStorage.clear();
            window.location.replace("/login");
        }
        yield put(authGetAuthenticationDetailsResult(null, exc?.error || exc?.message || 'Unknown error'))
        ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'getAuthenticationDetails');
    }
}

function* watchLoginRequests() {
    yield takeEvery(AUTH_REFRESH_TOKEN, refreshToken);
    yield takeEvery(AUTH_CHANGE_PASSWORD_REQUEST, changePassword);
    yield takeEvery(AUTH_GET_PREFERENCES_REQUEST, getPreference);
    yield takeEvery(AUTH_GET_AUTHENTICATION_DETAILS_REQUEST, getAuthenticationDetails);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchLoginRequests)
    ]);
}